import { useAtom } from "jotai";
import { atomFamily, atomWithStorage, useAtomValue } from "jotai/utils";

import * as flowConfig from "flows/profile-discovery/config";

const PREFIX = `${flowConfig.FLOW_NAME}/create`;

const inputFile = atomWithStorage<string>(`${PREFIX}/input-file`, null);

export const useInputFile = () => useAtom(inputFile);

export const useGetInputFile = () => useAtomValue(inputFile);

const idColumns = atomFamily((fileId: string) =>
  atomWithStorage<string[]>(`${PREFIX}/${fileId}/id-columns`, [])
);

export const useIDColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtom(idColumns(fileId));
};

export const useGetIDColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtomValue(idColumns(fileId));
};

const attributeColumns = atomFamily((fileId: string) =>
  atomWithStorage<string[]>(`${PREFIX}/${fileId}/attribute-columns`, [])
);

export const useAttributeColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtom(attributeColumns(fileId));
};

export const useGetAttributeColumns = () => {
  const fileId = useAtomValue(inputFile);
  return useAtomValue(attributeColumns(fileId));
};
